var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vcita-meter",class:{'single-line': _vm.singleLine}},[_c('VSvgIcon',{staticClass:"vcita-meter-icon",attrs:{"tag":"28","size":"28","icon":_vm.icon}}),_c('div',{staticClass:"vcita-meter-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"vcita-meter-value"},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }